:host {
  display: block;
  width: 100%;
  height: 100%;
}

.chart-container {
  width: 100%;
  height: 100%;
}

#chart {
  width: 100%;
  height: 100%;
}